import City from '@/views/city/City.vue'

export default [
    {
        // 城市列表
        path: '/city',
        name: 'City',
        component: City
    }
]
